export default __webpack_public_path__ + "static/TIMBERLINE-L-SERIES-28-O-front-WEB-726115908f6f9706303c239029837e6f.png";